import { createContext, useContext } from "react";
import type { InstructorClientSummary } from "../integrations/supabase/instructor";

export type ActiveInstructorClient = {
  clientUserId: string;
  /** Falls back to "Client" until the summary resolves, so the banner never renders blank. */
  displayName: string;
  /** Null until loaded, or when the link is gone — see `isLoading` / `isError` to tell apart. */
  summary: InstructorClientSummary | null;
};

export type InstructorClientContextValue = {
  /**
   * Non-null as soon as the URL carries a client id, before the summary resolves, so the owner
   * context keys on the client immediately and never renders the instructor's own data under a
   * client route.
   */
  activeClient: ActiveInstructorClient | null;
  isLoading: boolean;
  isError: boolean;
};

export const InstructorClientContext = createContext<InstructorClientContextValue>({
  activeClient: null,
  isLoading: false,
  isError: false,
});

/**
 * Which client an instructor currently has open, derived from the URL. Read by the owner-context
 * resolution, the client-view banner, the sidebar, and the chart page.
 */
export const useInstructorClient = () => useContext(InstructorClientContext);
